import { MAP_LEGEND_ENTRIES, MAP_ROLE_ACCENTS } from '../data/portfolioNodes';

export default function MapLegend({
  title = 'Legend',
  entries = MAP_LEGEND_ENTRIES,
  note = null,
  label = 'Node color legend',
  className = '',
  interactive = false,
  activeRole = null,
  onEntryEnter = null,
  onEntryLeave = null,
}) {
  return (
    <aside className={`map-legend animFade two${className ? ` ${className}` : ''}`} aria-label={label}>
      <p className="map-legend-title">{title}</p>
      <ul
        className="map-legend-list"
        onPointerLeave={interactive ? () => onEntryLeave?.() : undefined}
        onMouseLeave={interactive ? () => onEntryLeave?.() : undefined}
      >
        {entries.map(({ role, label: rowLabel, color, percent }) => (
          <li
            key={role}
            className={[
              'map-legend-row',
              interactive ? 'is-interactive' : '',
              activeRole === role ? 'is-active' : '',
            ].filter(Boolean).join(' ')}
            onPointerEnter={interactive ? () => onEntryEnter?.(role) : undefined}
            onMouseEnter={interactive ? () => onEntryEnter?.(role) : undefined}
          >
            <span
              className="map-legend-swatch"
              style={{ background: color || MAP_ROLE_ACCENTS[role] }}
              aria-hidden
            />
            <span className="map-legend-label">{rowLabel}</span>
            {percent != null ? <span className="map-legend-percent">{percent}%</span> : null}
          </li>
        ))}
      </ul>
      {note ? <p className="map-legend-note">{note}</p> : null}
    </aside>
  );
}
